// some of these will change when upgrading to v28 of AG Grid.
// we will also have the ability to switch to using CSS variables, if we want.

export const AgGridIcons = {
	filter: '<span class="q-icon q-icon-filter"></span>',
	groupContracted: '<span class="q-icon q-icon-folder-closed" aria-hidden="true"></span>',
	groupExpanded: '<span class="q-icon q-icon-folder-open" aria-hidden="true"></span>',
	eye: '<span class="q-icon q-icon-eye"></span>'
};
